import React from "react";
import PropTypes from "prop-types";
import {PaymentElement, useElements, useStripe} from "@stripe/react-stripe-js";
import {useDispatch} from "react-redux";
import {appActions} from "../../../../store/slices/app/appSlice";
import {reservationActions} from "../../../../store/slices/reservation/reservationSlice";
import {ReservationRoutes} from "../../routes";

const CheckoutForm = props => {
    const {submitRef} = props;
    const stripe = useStripe();
    const elements = useElements();
    const dispatch = useDispatch();
    const cur = window.location.href;
    const return_url = cur.replace(/\/[^\/]*$/, `/${ReservationRoutes.Finished}`)
    console.log('return_url', return_url);
    const onSubmit = async () => {
        if (!stripe || !elements) {
            return;
        }
        dispatch(appActions.setAppLoading(true));
        const cur = window.location.href;
        const return_url = cur.replace(/\/[^\/]*$/, `/${ReservationRoutes.Finished}`)
        console.log('return_url', return_url);
        const result = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url
            },
            // redirect: 'if_required'
        });
        if(result.error) {
            console.log('error', result.error)
            dispatch(reservationActions.setCardError(true));
            dispatch(reservationActions.setForceTimer(true));
        } else {
            console.log('res', result)
        }
        dispatch(appActions.setAppLoading(false));
    }

    submitRef.current = onSubmit;

    return (<form id="payment-form" style={{width: '100%'}} onSubmit={onSubmit}>
        <PaymentElement />
    </form>);
}

CheckoutForm.propTypes = {
    submitRef: PropTypes.object
}

export default CheckoutForm;
